import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  QCPatientVisitsDatesState,
  QCPatientVisitsDatesFetchAction,
  QCPatientVisitsDatesFetchSuccessAction,
  QCPatientVisitUpdateOrderAction,
  QCPatientVisitLockAction,
  QCPatientVisitUnlockAction,
} from './QCPatientVisitsDates.types';
import { createSliceHook } from '../helpers';

const initialState: QCPatientVisitsDatesState = {
  loading: false,
  data: null,
  error: undefined,
};

export const QCPatientVisitsDatesSlice = createSlice({
  name: 'QCPatientVisitsDates',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fetchQCPatientVisitsDates: (state, _: QCPatientVisitsDatesFetchAction) => {
      state.loading = true;
      state.error = undefined;
    },
    fetchQCPatientVisitsDatesSuccess: (
      state,
      action: QCPatientVisitsDatesFetchSuccessAction
    ) => {
      state.data = action.payload;
      state.loading = false;
      state.error = undefined;
    },
    fetchQCPatientVisitsDatesFailure: (state, action: PayloadAction<Error>) => {
      state.loading = false;
      state.error = action.payload;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateVisitOrder: (state, _: QCPatientVisitUpdateOrderAction) => {
      state.loading = true;
      state.error = undefined;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    lockVisit: (state, _: QCPatientVisitLockAction) => {
      state.loading = true;
      state.error = undefined;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    unlockVisit: (state, _: QCPatientVisitUnlockAction) => {
      state.loading = true;
      state.error = undefined;
    },
  },
});

export const actions = QCPatientVisitsDatesSlice.actions;

export const useQCPatientVisitsDatesSlice = createSliceHook(
  QCPatientVisitsDatesSlice.name,
  actions
);
